module.exports = ".search-in-table {\n  padding-top: 10px !important; }\n\n.mat-raised-button {\n  border-radius: 0; }\n"